import React from 'react';

type TasksSummaryProps = {
    completed: number,
    inProgress: number,
    notStarted: number
}

export const TasksSummary = (props: TasksSummaryProps) => {
    return <div className="card mb-4">
        <div className="card-body">
            <div className="list-group list-group-flush">
                <a style={{textAlign:'center'}} className="list-group-item list-group-item-action waves-effect">
                    <span style={{ width: '150px', display: 'inline-block' }}>Kompletní</span>
                    <span style={{ width: '40px', display: 'inline-block', textAlign: 'center' }} className="badge badge-success badge-pill pull-right">{props.completed}</span>
                </a>
                <a  style={{textAlign:'center'}} className="list-group-item list-group-item-action waves-effect">
                    <span style={{ width: '150px', display: 'inline-block' }}>Rozpracované</span>
                    <span style={{ width: '40px', display: 'inline-block', textAlign: 'center' }} className="badge badge-danger badge-pill pull-right">{props.inProgress}</span>
                </a>
                <a  style={{textAlign:'center'}} className="list-group-item list-group-item-action waves-effect">
                    <span style={{ width: '150px', display: 'inline-block' }}>Nezahájeno</span>
                    <span style={{ width: '40px', display: 'inline-block', textAlign: 'center' }} className="badge badge-primary badge-pill pull-right">{props.notStarted}</span>
                </a>
            </div>
        </div>
    </div>
}